/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ws_DescInputs */

const en_settings_ws_desc = /** @type {(inputs: Settings_Ws_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use it as the target when connecting a repo:`)
};

const id_settings_ws_desc = /** @type {(inputs: Settings_Ws_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai sebagai target saat menyambungkan repo:`)
};

/**
* | output |
* | --- |
* | "Use it as the target when connecting a repo:" |
*
* @param {Settings_Ws_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_ws_desc = /** @type {((inputs?: Settings_Ws_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ws_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_ws_desc(inputs)
	return en_settings_ws_desc(inputs)
});